import { useForm } from 'react-hook-form'
import Modal from 'src/components/Modal'
import * as S from './ModalConfirmDockFresh.styles'
import { useEffect } from 'react'
import { Typography } from '@mui/material'
import { handleOnKeyDown } from 'src/utils/Form'

interface ModalConfirmDockFreshProps {
  show: boolean
  isFresh: boolean
  onClose: () => void
  onAction: (badge: string) => void
}

interface FormData {
  badge: string
}

const ModalConfirmDockFresh = ({
  show,
  isFresh,
  onClose,
  onAction,
}: ModalConfirmDockFreshProps) => {
  const {
    register, trigger, getValues, resetField, formState: { errors },
  } = useForm<FormData>()

  useEffect(() => {
    resetField('badge')
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show])

  const onSubmit = async () => {
    const badgeValidation = await trigger('badge')

    if (!badgeValidation) {
      return
    }

    const badge = getValues('badge')

    onAction(badge)
  }

  return (
    <Modal
      show={show}
      testId='modal-confirm-dock-type-test-id'
      centered
      title='Confirme a mudança da doca'
      closeButtonAction={onClose}
      closedButton
      body={(
        <S.Container>
          <Typography variant='body1'>
            A doca atualmente é {isFresh ? 'Fresh' : 'Mercearia'}.
          </Typography>
          <Typography variant='body1'>
            Confirme a mudança para {!isFresh ? 'Fresh' : 'Mercearia'} bipando seu crachá.
          </Typography>
          <S.CustomTextField
            id='badge'
            name='badge'
            type='password'
            autoComplete='off'
            autoFocus
            inputProps={{
              ...register('badge', {
                required: 'Campo obrigatório',
              }),
              'data-testid': 'badge-input-test-id',
            }}
            error={!!errors.badge}
            label='badge'
            helperText={!!errors.badge && errors.badge.message}
            fullWidth
            size='medium'
            onKeyDown={(event) => handleOnKeyDown(event, '', onSubmit)}
          />
        </S.Container>
      )}
    />
  )
}

export default ModalConfirmDockFresh
